import { useFormikContext } from 'formik';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';
import {
  Email,
  Telephone,
  Text,
} from 'hb-react/shared/components/formik/components/inputs';

import { Captcha } from './Captcha';
import { Section } from './Section';
import { MODE } from '../constants';
import type { FormValues, ModeValues } from '../types';

export const Recruiter = ({
  image,
  mode,
}: {
  image?: string;
  mode: ModeValues;
}) => {
  const { values } = useFormikContext<FormValues>();

  const isActive =
    values.type_class === 'BusinessOpportunities::ExternalRecruiterRequest';

  const isReadOnly = mode === MODE.BO;

  return isActive ? (
    <Section title={s__('JobForm|Personal information')}>
      <Grid mx={0} numCols={2} rowGap={0}>
        <Row>
          <Col width={0.5}>
            <Text
              disabled={isReadOnly}
              id="external_recruiter[username]"
              label={s__('JobForm|Your name')}
              name="external_recruiter[username]"
              validate={{ required: true }}
            />
          </Col>
          <Col width={0.5}>
            <Telephone
              disabled={isReadOnly}
              id="external_recruiter[phone_number]"
              label={s__('JobForm|Phone number')}
              name="external_recruiter[phone_number]"
              /* @ts-expect-error `maxLength`/`minLength` not required */
              validate={{ required: true }}
            />
          </Col>
          <Col width={0.5}>
            <Email
              disabled={isReadOnly}
              id="external_recruiter[email]"
              label={s__('JobForm|Email')}
              name="external_recruiter[email]"
              validate={{ required: true }}
            />
          </Col>
          <>
            {image && (
              <Col width={0.5}>
                <Captcha image={image} />
              </Col>
            )}
          </>
        </Row>
      </Grid>
    </Section>
  ) : null;
};
